import { useState } from 'react';
import loadable from '@loadable/component';

import { Button } from '@simplywallst/ui-core';
import PlusSolid from '@simplywallst/ui-core/icons/PlusSolid';
import If from '@components/If';

const GuestRegistrationModal = loadable(
  () => import('@/components/GuestRegistrationModal')
);

export const UnauthenticatedFollowNarrative = () => {
  const [modal, setModal] = useState<boolean>(false);

  return (
    <>
      <If match={modal}>
        {() => (
          <GuestRegistrationModal
            canClose={true}
            removeWindowScroll={true}
            onClose={() => setModal(false)}
          />
        )}
      </If>
      <Button
        alignIcon="left"
        display="inline"
        onClick={() => setModal(true)}
        styleType="loud"
      >
        <PlusSolid />
        Follow Narrative
      </Button>
    </>
  );
};
